import React from "react";
import { motion } from "framer-motion";
import hero1 from "../assets/hero1.jpeg";
import hero2 from "../assets/hero2.jpeg";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="relative min-h-screen bg-dreamy-cream overflow-hidden flex items-center px-6 md:px-20 pt-20">
      {/* Background Aesthetic Blur */}
      <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-dreamy-gold/30 blur-[120px] rounded-full -z-0" />
      <div className="absolute bottom-[10%] left-[-5%] w-[300px] h-[300px] bg-orange-200/20 blur-[100px] rounded-full -z-0" />

      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center z-10">
        {/* LEFT SIDE: TEXT CONTENT */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="flex flex-col gap-6"
        >
          <div className="space-y-2">
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="font-sans text-xs tracking-[0.3em] uppercase text-dreamy-earth/60"
            >
              Based in Sri Lanka
            </motion.span>
            <h2 className="font-serif text-5xl md:text-8xl text-dreamy-earth leading-[1.1]">
              Preserving the <br />
              <span className="italic font-light text-dreamy-gold">
                Quiet Moments
              </span>
            </h2>
          </div>

          <p className="font-sans text-dreamy-earth/70 max-w-md leading-relaxed text-lg">
            A blend of vintage aesthetics and natural light. Capturing the world
            through a soft, dreamy lens.
          </p>

          <motion.div whileHover={{ scale: 1.05 }} className="w-fit">
            <Link
              to="/gallery"
              className="px-8 py-4 bg-dreamy-earth text-dreamy-cream rounded-full font-sans text-sm tracking-widest uppercase hover:bg-opacity-90 transition-all shadow-lg shadow-dreamy-earth/10"
            >
              View Collection
            </Link>
          </motion.div>
        </motion.div>

        {/* RIGHT SIDE: IMAGE COMPOSITION */}
        <div className="relative flex justify-center items-center">
          {/* Main Large Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.5, ease: "easeOut" }}
            className="relative w-[300px] h-[450px] md:w-[400px] md:h-[550px] overflow-hidden rounded-t-full shadow-2xl z-10 border-[12px] border-white/50"
          >
            <img
              src={hero1} // Replace with a vertical portrait
              alt="Portrait Photography"
              className="w-full h-full object-cover grayscale-[10%] sepia-[10%] brightness-105"
            />
          </motion.div>

          {/* Secondary Overlapping Image (Nature Vibe) */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 1.2 }}
            className="absolute -bottom-10 -left-4 md:-left-12 w-48 h-48 md:w-64 md:h-64 overflow-hidden rounded-2xl shadow-xl z-20 border-8 border-white/80 rotate-[-5deg]"
          >
            <img
              src={hero2} // Replace with a nature/flower detail shot
              alt="Nature Detail"
              className="w-full h-full object-cover"
            />
          </motion.div>
        </div>
      </div>

      {/* Decorative "Vintage" Grain Overlay Element */}
      <div className="fixed inset-0 pointer-events-none z-[100] opacity-[0.03] bg-[url('https://grainy-gradients.vercel.app/noise.svg')]"></div>
    </section>
  );
};

export default Hero;
